import React from 'react';
import { Navigate } from 'react-router-dom';
import { BaseSpin } from '@components';
import { USER_TYPES } from '@constants/userTypes.ts';
import { useAppSelector } from '@hooks/reduxHooks.ts';
import { useUserRoles } from '@hooks/useUserRoles.ts';
import { ROUTES } from '@router/constants.ts';
import { getStartPagesOptions, START_PAGE_VALUES } from '@routes/sidebar/settings/ui/user-preferences-tab/constants.ts';
import { filterStartPageOptionsByUserAccess } from '@utils/roles.ts';

const getAbsoluteRoute = (route: string) => (route.startsWith('/') ? route : `/${route}`);

// Valid preferred landingPage → go there
// No preferred landingPage / invalid landingPage + Crew or Office → /my-profile
// Other case → first allowed start page or /learning

const Home: React.FC = () => {
    const userInfo = useAppSelector((state) => state.user.userInfo);
    const userRoles = useUserRoles();

    if (!userInfo) {
        return <BaseSpin />;
    }

    const preferredStartPage = userInfo.preferences?.landingPage;
    const allowedStartPages = filterStartPageOptionsByUserAccess(userInfo, getStartPagesOptions(), userRoles);

    const hasAccessToPreferredStartPage = allowedStartPages.some(
        (option) => String(option.value) === preferredStartPage,
    );

    if (preferredStartPage && hasAccessToPreferredStartPage) {
        return <Navigate to={getAbsoluteRoute(preferredStartPage)} replace />;
    }

    if (userInfo.userType === USER_TYPES.Crew || userInfo.userType === USER_TYPES.Office) {
        return <Navigate to={getAbsoluteRoute(ROUTES.PROFILE_BAR.MY_PROFILE)} replace />;
    }

    const fallbackStartPage = String(allowedStartPages[0]?.value ?? START_PAGE_VALUES.LEARNING);

    return <Navigate to={getAbsoluteRoute(fallbackStartPage)} replace />;
};

export default Home;
